import { properties as propertiesCloudConfig } from 'config/Config';

//Declaracion de objetos con atributos
export const objAtrib = {
    gridPrincipal: {
        id: 'gridPrincipal'
    },
    gridContenedor: {
        id: 'gridContenedor'
    },
    tituloEncabezado: {
        id: 'encabezado'
    },
    button: {
        id: 'btnAtras',
        name: 'btnAtras',
        class: 'btn btn-secondary'
    }
}

export const compProperties = {
    CONFIR_SI_NO: 'confirSiNo',
    CONFIR_CANCELAR_ACEPTAR: 'confirCancelarAceptar',
    CONFIR_SOLO_ACEPTAR: 'confirSoloAceptar',
    CONFIR_SIN_ACCION: 'sinAccion',
}

export const objText = {
    tituloEncabezado: 'Creación de Formularios',
    tituloBotonAtras: 'Atrás',
    popup: {
        titulo: 'AVISO',
        mensaje: 'No se han guardado los campos introducidos en el formulario. Si continua volverá al Módulo de administración, ¿desa continuar?.',
        botonera: compProperties.CONFIR_CANCELAR_ACEPTAR,
        accionDenegacion: compProperties.CONFIR_SIN_ACCION
    }
}

export const msgError = {
    severity: 'Error',
    error: 'Ha ocurrido un error al intentar recuperar los datos.'
}

export const properties = {
    base: `${propertiesCloudConfig['CECEU_FORMIO_SERVER']}`,
    project: `${propertiesCloudConfig['CECEU_FORMIO_SERVER']}/project`,
    resourceTag: null
}